<ion-spinner name="crescent"></ion-spinner>
